import {
  PaxCheckAllowedDocument,
  PaxCheckAllowedDocumentFormat,
  PaxCheckAllowedDocumentsSet,
  PaxCheckDocumentMrzConfiguration,
  PaxCheckDocumentProvisionMethod,
  PaxCheckDocumentSidesConfiguration,
  PaxCheckDocumentSidesExpectation,
} from "api";

// TODO refactor
// only used to store a string value "PASSPORT"
// - for specific business logic when need to compare PaxCheck API outputs by text value.
// Different from ChecklistItemType (TRAVEL_DOC).
// -> this will gone as part of further refactoring, when we
// drift away from a notion of Passport in webview towards general Travel document
export enum AllowedDocumentType {
  Passport = "PASSPORT",
}

export class AllowedDocumentsSet {
  shouldUseItemResolver: boolean;
  allowedDocuments: Array<AllowedDocument>;
  isScanPossibleForAny: boolean;

  constructor(
    shouldUseItemResolver: boolean,
    allowedDocuments: Array<AllowedDocument>,
    isScanPossibleForAny: boolean
  ) {
    this.shouldUseItemResolver = shouldUseItemResolver;
    this.allowedDocuments = allowedDocuments;
    this.isScanPossibleForAny = isScanPossibleForAny;
  }

  static fromApi(c?: PaxCheckAllowedDocumentsSet): AllowedDocumentsSet {
    const allowedDocuments =
      c?.allowedDocuments.map((doc) => AllowedDocument.fromApi(doc)) || [];

    const isScanPossibleForAll = allowedDocuments.every((doc) => {
      return doc.isScanPossible();
    });
    const isUploadPossibleForAll = allowedDocuments.every((doc) => {
      return doc.isUploadPossible();
    });

    const isScanPossibleForAny = allowedDocuments.some((doc) => {
      return doc.isScanPossible();
    });
    const isUploadPossibleForAny = allowedDocuments.some((doc) => {
      return doc.isUploadPossible();
    });

    // TODO transfer this logic to backend?
    const shouldUseItemResolver =
      c?.forceDocumentTypeRequired ||
      !(
        (isScanPossibleForAll || !isScanPossibleForAny) &&
        (isUploadPossibleForAll || !isUploadPossibleForAny)
      );

    return new AllowedDocumentsSet(
      shouldUseItemResolver,
      allowedDocuments,
      isScanPossibleForAny
    );
  }
}

export interface AllowedDocumentProps {
  type: string;
  format: PaxCheckAllowedDocumentFormat;
  title: string;
  description?: string | null;
  provisionMethods: Array<PaxCheckDocumentProvisionMethod>;
  sidesConfiguration: PaxCheckDocumentSidesConfiguration;
  sidesExpectation: PaxCheckDocumentSidesExpectation;
  sideWithMrz: PaxCheckDocumentMrzConfiguration;
  multipaxResolutionSupported: boolean;
  expectLongProcessing: boolean;
  sampleImageUrl?: string | null;
  country?: string | null;
  pageIndexToProcess?: number | null;
}

export class AllowedDocument {
  type: string;
  format: PaxCheckAllowedDocumentFormat;
  title: string;
  description?: string | null;
  provisionMethods: Array<PaxCheckDocumentProvisionMethod>;
  sidesConfiguration: PaxCheckDocumentSidesConfiguration;
  sidesExpectation: PaxCheckDocumentSidesExpectation;
  sideWithMrz: PaxCheckDocumentMrzConfiguration;
  multipaxResolutionSupported: boolean;
  expectLongProcessing: boolean;
  sampleImageUrl?: string | null;
  country?: string | null;
  pageIndexToProcess?: number | null;

  constructor(props: AllowedDocumentProps) {
    this.type = props.type;
    this.format = props.format;
    this.title = props.title;
    this.description = props.description;
    this.provisionMethods = props.provisionMethods;
    this.sidesConfiguration = props.sidesConfiguration;
    this.sidesExpectation = props.sidesExpectation;
    this.sideWithMrz = props.sideWithMrz;
    this.multipaxResolutionSupported = props.multipaxResolutionSupported;
    this.sampleImageUrl = props.sampleImageUrl;
    this.country = props.country;
    this.pageIndexToProcess = props.pageIndexToProcess;
    this.expectLongProcessing = props.expectLongProcessing;
  }

  static fromApi(c: PaxCheckAllowedDocument): AllowedDocument {
    return new AllowedDocument({
      type: c.type,
      format: c.documentFormat,
      title: c.title,
      description: c.description,
      provisionMethods: c.provisionMethods,
      sidesConfiguration: c.sidesConfiguration,
      sidesExpectation: c.sidesExpectation,
      sideWithMrz: c.sideWithMrz,
      multipaxResolutionSupported: c.multipaxResolutionSupported,
      sampleImageUrl: c.sampleImageSrc,
      country: c.country,
      pageIndexToProcess: c.pageIndexToProcess,
      expectLongProcessing: c.expectLongProcessing,
    });
  }

  public isScanPossible(): boolean {
    return this.provisionMethods.some(
      (method) => method === PaxCheckDocumentProvisionMethod.SCAN
    );
  }

  public isUploadPossible(): boolean {
    return this.provisionMethods.some(
      (method) => method === PaxCheckDocumentProvisionMethod.UPLOAD
    );
  }

  public isManualPossible(): boolean {
    return this.provisionMethods.some(
      (method) => method === PaxCheckDocumentProvisionMethod.MANUAL
    );
  }

  public isMultiSideExpected(): boolean {
    return (
      this.sidesExpectation === PaxCheckDocumentSidesExpectation.ALL &&
      this.sidesConfiguration !==
        PaxCheckDocumentSidesConfiguration.SINGLE_SIDE_OR_FILE
    );
  }
}

export default AllowedDocument;
